import React from "react";
import { Link, useLocation } from "react-router-dom";
import "./NotFound.css";

export default function NotFound() {
  const location = useLocation();

  return (
    <main className="nf">
      <div className="nf-card">
        <p className="nf-eyebrow">ERROR 404</p>

        <h1 className="nf-title">Página no encontrada</h1>

        <p className="nf-subtitle">
          No existe la ruta <span className="nf-path">{location.pathname}</span>.
          Puedes volver al inicio o explorar las secciones principales.
        </p>

        <div className="nf-actions">
          <Link className="nf-btn" to="/">Ir al inicio</Link>
          <Link className="nf-link" to="/#servicios">Ver servicios</Link>
          <Link className="nf-link" to="/#proyectos">Ver proyectos</Link>
        </div>

        <div className="nf-hint">
          Tip: revisa el enlace o vuelve al menú.
        </div>
      </div>
    </main>
  );
}